<div class="d-flex flex-column align-items-center p-3">
  <div class="spinner">
    <div class="rect1"></div>
    <div class="rect2"></div>
    <div class="rect3"></div>
    <div class="rect4"></div>
    <div class="rect5"></div>
  </div>

  <p class="m-0 text-muted">{{ 'GENERAL.LOADING_TEXT' | translate }}</p>
</div>
